import { c as _c } from "react/compiler-runtime";
import { useUrlFilters } from "@/hooks/use-url-filters";
import { mapDefaults } from "@/info/map-defaults";
import { useSearchPageMapData } from "@/providers/search";
import { useEffect, useRef } from "react";
interface UseMapUrlSyncProps {
  backendMapCenter?: {
    lat: number;
    lng: number;
  } | null;
  coordinates?: {
    lat: number;
    lng: number;
  } | null;
}

/**
 * Simplified hook for map-URL synchronization.
 * Since URL is now the single source of truth, this hook only handles:
 * 1. Initial coordinate setup from backend data
 * 2. Zoom synchronization from URL to map state
 */
export function useMapUrlSync(t0) {
  const $ = _c(13);
  const {
    backendMapCenter,
    coordinates
  } = t0;
  const {
    filters,
    setFilters
  } = useUrlFilters();
  const setMapZoom = useSearchPageMapData(_temp);
  const hasInitializedRef = useRef(false);
  let t1;
  let t2;
  if ($[0] !== backendMapCenter || $[1] !== coordinates || $[2] !== filters || $[3] !== setFilters) {
    t1 = () => {
      if (hasInitializedRef.current) {
        return;
      }
      hasInitializedRef.current = true;
      const updatedFilters = {
        ...filters
      };
      let hasChanges = false;
      if (filters.zoom === undefined) {
        updatedFilters.zoom = mapDefaults.zoom;
        hasChanges = true;
      }
      if (!coordinates && !filters.coordinates && backendMapCenter) {
        updatedFilters.coordinates = {
          lat: parseFloat(backendMapCenter.lat.toFixed(6)),
          lng: parseFloat(backendMapCenter.lng.toFixed(6))
        };
        hasChanges = true;
      }
      if (hasChanges) {
        setFilters(updatedFilters, {
          useReplaceState: true
        });
      }
    };
    t2 = [backendMapCenter, coordinates, filters, setFilters];
    $[0] = backendMapCenter;
    $[1] = coordinates;
    $[2] = filters;
    $[3] = setFilters;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[6] !== filters.zoom || $[7] !== setMapZoom) {
    t3 = () => {
      if (filters.zoom !== undefined) {
        setMapZoom(filters.zoom);
      }
    };
    t4 = [filters.zoom, setMapZoom];
    $[6] = filters.zoom;
    $[7] = setMapZoom;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] !== filters || $[11] !== setFilters) {
    t5 = {
      updateUrlCoordinates: newCenter => {
        const roundedCenter = {
          lat: parseFloat(newCenter.lat.toFixed(6)),
          lng: parseFloat(newCenter.lng.toFixed(6))
        };
        setFilters({
          ...filters,
          coordinates: roundedCenter
        }, {
          useReplaceState: true
        });
      }
    };
    $[10] = filters;
    $[11] = setFilters;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp(state) {
  return state.setMapZoom;
}